module.exports = __webpack_public_path__ + "img/default_bg.175e4fc7.jpg";